import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import {Box, Paper, Button, Typography} from '@material-ui/core';
import {makeHighlightStyle} from 'theme';
import stringFromNode from 'helpers/stringFromNode';
import {useFlashCardRevealResponse} from 'data/queries/responses';

const useStyles = makeStyles(theme => {
  const highlightStyle = makeHighlightStyle(theme);
  return {
    prompt: {
      marginBottom: theme.spacing(0.25),
      display: 'block',
    },
    card: highlightStyle({
      colors: theme.palette.legacy.actionHighlight.info,
      before: {content: `'\\e8fd'`}, // help_outline e8fd
    }),
  };
});

const FlashCard = ({prompt, answer, selfcheck}) => {
  const [revealed, setRevealed] = React.useState(false);
  const promptText = stringFromNode(prompt);
  const [_, createResponse] = useFlashCardRevealResponse(promptText);
  const reveal = () => {
    setRevealed(true);
    createResponse();
  };

  const classes = useStyles({revealed});

  // if there's a selfcheck child element
  // we add a 'promptText' prop
  const selfcheckWithPromptText = selfcheck && React.cloneElement(selfcheck, {promptText});

  return (
    <Box marginBottom={4} className={classes.card}>
      <Typography component="div" variant="body1">
        <Box component="div" mt={1} mb={3}>
          {prompt}
        </Box>
        <Box mt={4} mb={4}>
          {revealed ? (
            <Paper>
              <Box p={2}>
                <Box>{answer}</Box>
                {selfcheckWithPromptText && <Box mt={4}>{selfcheckWithPromptText}</Box>}
              </Box>
            </Paper>
          ) : (
            <Button
              type="submit"
              variant="outlined"
              color="inherit"
              disabled={revealed}
              onClick={reveal}
            >
              Show answer
            </Button>
          )}
        </Box>
      </Typography>
    </Box>
  );
};

FlashCard.propTypes = {
  prompt: PropTypes.node.isRequired,
  answer: PropTypes.node.isRequired,
  selfcheck: PropTypes.node,
};

export default FlashCard;
